<script setup lang="ts">
defineProps<{
	name: string
	title: string
	type?: 'text' | 'number' | 'password'
	modelValue?: string | number
	wide?: boolean
	required?: boolean
}>()

defineEmits<{
	'update:modelValue': [value: string]
}>()
</script>

<template>
	<label :class="['c-input', wide && 'c-input--wide']">
		<span class="c-input__title">{{ title }}</span>
		<input
			class="c-input__input"
			:type="type ?? 'text'"
			:name="name"
			:value="modelValue"
			:required="required"
			@input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
		/>
	</label>
</template>
